// extracted by mini-css-extract-plugin
export default {"body":"withdraw-modal_body__54X3L","description":"withdraw-modal_description__N+avI","footer":"withdraw-modal_footer__HQKDi"};